/**
 * Loading spinner component.
 */

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
}

export default function LoadingSpinner({ size = 'md', text }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-2">
      <div
        className={`${sizeClasses[size]} border-4 border-orbital-200 dark:border-orbital-800 border-t-orbital-600
                    rounded-full animate-spin`}
      />
      {text && <p className="text-sm text-content-secondary">{text}</p>}
    </div>
  );
}
